export default "__VITE_ASSET__M0mbMxMt__"